import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import { IconButton, Tooltip } from "@mui/material";
import style from "./Listlet.module.css";

export interface Props {
  deleteCallback?: () => void;
  renameCallback?: () => void;
  onUploadImage?: () => void;
  numerator: number;
  heading: string;
  description?: string;
  imageUrl?: string;
  score: number;
}

export default function Listlet(props: Props) {
  let rankClass = "";
  if (props.numerator === 1) {
    rankClass = style.gold;
  } else if (props.numerator === 2) {
    rankClass = style.silver;
  } else if (props.numerator === 3) {
    rankClass = style.bronze;
  }

  return (
    <>
      <div className={`${style.container} ${rankClass}`}>
        <div className={style.numerator}>{props.numerator}</div>

        {props.imageUrl && (
          <div className={style.image}>
            <img className={style.img} src={props.imageUrl} alt={props.heading} />
          </div>
        )}

        <div className={style.right}>
          <p className={style.heading}>{props.heading}</p>
          {props.description && <p className={style.description}>{props.description}</p>}
          <span className={style.score}>Score: {props.score}</span>
        </div>

        <div className={style.actions}>
          {props.onUploadImage && (
            <Tooltip title={props.imageUrl ? "Replace Image" : "Upload Image"}>
              <IconButton
                type="button"
                className={style.upload}
                onClick={props.onUploadImage}
              >
                <PhotoCameraIcon />
              </IconButton>
            </Tooltip>
          )}
          {props.renameCallback && (
            <IconButton
              type="button"
              className={style.rename}
              onClick={props.renameCallback}
            >
              <EditIcon />
            </IconButton>
          )}
          {props.deleteCallback && (
            <IconButton
              type="button"
              className={style.delete}
              onClick={props.deleteCallback}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </div>
      </div>
    </>
  );
}
